module.exports = __webpack_public_path__ + "static/img/招标-1.0811aa2c.png";